module.exports = __webpack_public_path__ + "img/cointelegraph.1ae7e00c.png";